// extracted by mini-css-extract-plugin
export default {"wrapper":"success_wrapper__f53G5","opacity-transition":"success_opacity-transition__+P3Ef"};